import { FormattedText, Icon, Typography } from 'src/modules/core/components'
import classes from './confirmation-message.module.scss'

import type { ConfirmationErrorKind, ConfirmationMessageProps } from './confirmation-message.interface'

const ERROR_MESSAGE_IDS: Record<ConfirmationErrorKind, string> = {
  invalid_link: 'confirmation.error.invalidLink',
  load_failed: 'confirmation.error.loadFailed',
  event_past: 'confirmation.error.eventPast',
  appointment_not_found: 'confirmation.error.appointmentNotFound',
  cannot_process: 'confirmation.error.cannotProcess',
}

export function ConfirmationMessage({ variant, errorKind }: ConfirmationMessageProps) {
  const errorId =
    variant === 'error' ? (ERROR_MESSAGE_IDS[errorKind ?? 'load_failed'] ?? 'confirmation.error.loadFailed') : null

  return (
    <div>
      <div className={classes.confirmationMessageWrapper}>
        <div className={classes.confirmationSuccessMark}>
          {variant === 'success' && <Icon name="checkmark" className={classes.checkIcon} />}
          {(variant === 'canceled' || variant === 'error') && <Icon name="calendarCanceled" />}
        </div>
        <Typography variant="body" className={classes.text}>
          {variant === 'success' && <FormattedText id="confirmation.confirmed" />}
          {variant === 'canceled' && <FormattedText id="confirmation.canceled" />}
          {variant === 'error' && <FormattedText id={errorId} />}
        </Typography>
      </div>
    </div>
  )
}
